import ComoLlego from './ComoLlego'

export default ComoLlego
